<template>

  <div ref="formStep" class="form-step" data-step="1">
    <div>
      <div ref="formContent" class="form-content">
        <form @submit.prevent="submitForm">
          <div class="form-group">
            <label for="firstName">{{ $t('formContent.Step2formLabel')}}</label>
            <input
                @input="checkInput"
                id="firstName"
                ref="firstNameInput"
                v-model="localFormData.firstName"
                type="text"
                :placeholder="$t('formContent.Step2formLabel')"
                required
            />
          </div>
          <button
              ref="nextStepButton"
              :class="{ 'disabled': isButtonDisabled }"
              type="submit"
              class="button nextstep">
            <span>{{ $t('formContent.Step2formButton')}}</span><img src="@/assets/img/arrow-right.svg"/>
          </button>
        </form>


      </div>

    </div>
  </div>
</template>

<script>
import {gsap} from "gsap";
import {ref, onMounted} from "vue";

export default {
  props: {
    formData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      // Erstellen einer lokalen Kopie der Prop-Daten
      localFormData: JSON.parse(JSON.stringify(this.formData)),
    };
  },
  computed: {
    isButtonDisabled() {
      return !this.localFormData.firstName || this.localFormData.firstName.length === 0;
    }
  },
  mount() {
    this.initView();
  },
  methods: {
    focusInput() {
      this.$refs.firstNameInput.focus();
    },
    submitForm() {
      // Senden eines Ereignisses mit der aktualisierten lokalen Kopie der Daten
      this.$emit('update', this.localFormData);
      this.$emit('next');
    },
    initView() {
      this.focusInput();
    }
  },
  setup() {
    const image1 = ref(null);
    const image2 = ref(null);
    const formContent = ref(null);
    const nextStepButton = ref(null);
    const formStep = ref(null);

    onMounted(() => {
      var splitTextTimeline = gsap.timeline();
      splitTextTimeline.to(formStep.value, {display:"flex", autoAlpha:1});
      splitTextTimeline.from(formContent.value, {autoAlpha: 0, yPercent: 40});
    });

    return {
      image1,
      image2,
      formContent,
      formStep,
      nextStepButton,
    };
  },
};
</script>

<style lang="scss" >
// @import 'src/assets/css/components/multistepform';
</style>


<style lang="scss" scoped>
.nextstep {
  transition: inherit;
}
</style>